"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphBlockRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const sentence_renderer_1 = require("./sentence-renderer");
exports.ParagraphBlockRenderer = (0, react_1.memo)(({ block, currentPlayTime, isCurrentParagraph, onSelect, }) => {
    const theme = (0, material_1.useTheme)();
    const playingIndex = (0, react_1.useMemo)(() => {
        if (isCurrentParagraph) {
            for (let i = block.sentences.length - 1; i >= 0; i--) {
                const sentence = block.sentences[i];
                if (currentPlayTime > sentence.audioOffset + sentence.audioDuration) {
                    return i + 1; // Return the next sentence index
                }
            }
            return 0; // If no sentence is playing, return 0
        }
    }, [block.sentences, currentPlayTime, isCurrentParagraph]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", flexWrap: "wrap", children: [(0, jsx_runtime_1.jsx)(material_1.Box, { width: theme.spacing(12) }), block.sentences.map((sentence, index) => {
                return ((0, jsx_runtime_1.jsx)(sentence_renderer_1.SentenceRenderer, { sentence: sentence, currentPlayTime: playingIndex === index && isCurrentParagraph
                        ? currentPlayTime
                        : undefined, onSelect: onSelect }, index));
            })] }));
});
exports.ParagraphBlockRenderer.displayName = "ParagraphBlockRenderer";
